export const MAX_KNOWN_REVIEW_COUNT = 100;
